import { Navigate } from "react-router-dom";
import usePermissions from "../../hooks/usePermissions";
import { hasAnyReportAccess } from "../../utils/reportAccess";

// Permission Gate - redirects to calendar if user doesn't have canView permission for a section.
// (Moved verbatim out of App.js so the admin route gating can be tested.)
const PermissionGate = ({ section, children }) => {
  const perms = usePermissions();
  const sectionPerms = perms?.[section];

  // For reports, any report permission opens the section (e.g. an Assistant
  // with no reports scope still has their own Earnings Summary).
  if (section === "reports") {
    const hasAccess = hasAnyReportAccess(sectionPerms);
    if (sectionPerms && !hasAccess) {
      return <Navigate to="/admin/calendar" replace />;
    }
    return children;
  }

  // For other sections, check canView !== false
  const canView = sectionPerms?.canView !== false;
  if (sectionPerms && !canView) {
    return <Navigate to="/admin/calendar" replace />;
  }
  return children;
};

export default PermissionGate;
